export default __webpack_public_path__ + "static/media/express.8427b1f1.svg";